import { logger } from '@belong/logging/logger';
import React from 'react';
import { Entry } from 'contentful';
import StandardTemplate from './standard';
import { IStandardTemplate } from './standard/model';

// type to list all available templates
export type ISupportArticleTemplate = IStandardTemplate;
export type ISupportArticleTransformer = (data: Entry<any>) => ISupportArticleTemplate;

export enum SUPPORT_ARTICLE_TEMPLATE {
  Standard = 'supportArticleTemplateStandard'
}

export const TEMPLATES = {
  supportArticleTemplateStandard: StandardTemplate
};

export const getTemplateView = (contentType: string): React.FC<any> => {
  const template = TEMPLATES[contentType];
  if (!template) {
    throw new Error('Template not found');
  }
  if (!template.view) {
    throw new Error('View not defined for template');
  }

  return template.view;
};

export const getTemplateTransformer = (contentType: string): ISupportArticleTransformer => {
  const template = TEMPLATES[contentType];
  if (!template) {
    throw new Error('Template not found');
  }
  if (!template.model) {
    throw new Error('Transformer not defined for template');
  }

  return template.model;
};

export const FArticleTemplate = (data: Entry<any>): ISupportArticleTemplate | null => {
  const contentType = data.sys.contentType.sys.id;
  let transformer: ISupportArticleTransformer;

  try {
    transformer = getTemplateTransformer(contentType);
  } catch (err) {
    logger.error(`FArticleTemplate - failed to load transformer for '${contentType}:`, err.message);
    return null;
  }

  try {
    return transformer(data);
  } catch (err) {
    logger.error(`FArticleTemplate - error transforming data for '${contentType}:`, err.message);
  }

  return null;
};

export default TEMPLATES;
